import { createContext, useContext } from 'react'
import { type AnalyticsLayoutStore } from 'pages/analytics/store/analyticsLayoutStore'

export const AnalyticsLayoutContext = createContext<AnalyticsLayoutStore | null>(null)

export const useAnalyticsLayoutContext = () => {
  const context = useContext(AnalyticsLayoutContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with AnalyticsLayoutContext')

  return context
}
